import { Drawer } from 'antd'
import { GeckoNotificationProvider } from 'features/notifications'
import { SymbolImport } from 'features/processFlowDiagrams'
import React from 'react'

import {
  CreateSystemDrawer,
  CreateSystemDrawerProps,
} from './drawerStates/createSystem/CreateSystemDrawer'
import {
  EditGeckoInspection,
  EditGeckoInspectionProps,
} from './drawerStates/crudWorkflows/editInspection/EditGeckoInspection'
import {
  EditGeckoOrganization,
  EditGeckoOrganizationProps,
} from './drawerStates/crudWorkflows/editOrganization/EditGeckoOrganization'
import {
  EditGeckoComponentDrawer,
  EditGeckoComponentDrawerProps,
} from './drawerStates/crudWorkflows/editRichAssetModel/EditGeckoComponentAndRichAssetModel'
import {
  EditGeckoSite,
  EditGeckoSiteProps,
} from './drawerStates/crudWorkflows/editSite/EditGeckoSite'
import {
  EditGeckoUnit,
  EditGeckoUnitProps,
} from './drawerStates/crudWorkflows/editUnit/EditGeckoUnit'
import {
  ImportGeckoInspection,
  ImportGeckoInspectionProps,
} from './drawerStates/crudWorkflows/importInspection/ImportGeckoInspection'
import {
  RAUTInspectionSync,
  RautInspectionSyncProps,
} from './drawerStates/rautInspectionSync/RAUTInspectionSync'
import { UploadFileProps } from './drawerStates/uploadFiles/UploadFile'
import { UploadFileDrawer } from './drawerStates/uploadFiles/UploadFileDrawer'
import {
  GeckoHHUTFileProps,
  UploadHHUTFile,
} from './drawerStates/uploadHhutFile/UploadHhutFile'
import { DrawerState } from './utils/enums'
import { RightSideDrawerProps } from './utils/interfaces'
import { useRightDrawer } from './utils/RightDrawerProvider'

export const RightSideDrawer = (): React.JSX.Element => {
  const { drawerState, closeDrawer } = useRightDrawer()

  const getChildElements = (): [
    React.ReactNode,
    RightSideDrawerProps | undefined,
  ] => {
    switch (drawerState) {
      case DrawerState.Closed:
        return [null, undefined]
      case DrawerState.UploadingState:
        return [null, undefined]
      case DrawerState.EditGeckoOrganization:
        return [
          <EditGeckoOrganization key='edit-org' />,
          EditGeckoOrganizationProps,
        ]
      case DrawerState.EditGeckoSite:
        return [<EditGeckoSite key='edit-site' />, EditGeckoSiteProps]
      case DrawerState.EditGeckoInspection:
        return [
          <EditGeckoInspection key='edit-inspection' />,
          EditGeckoInspectionProps,
        ]
      case DrawerState.ImportGeckoInspection:
        return [
          <ImportGeckoInspection key='import-inspection' />,
          ImportGeckoInspectionProps,
        ]
      case DrawerState.EditGeckoUnit:
        return [<EditGeckoUnit key='edit-unit' />, EditGeckoUnitProps]
      case DrawerState.TriggerRAUTGdriveRolodexSync:
        return [
          <RAUTInspectionSync key='trigger-raut-gdrive-rolodex-sync' />,
          RautInspectionSyncProps,
        ]
      case DrawerState.EditGeckoComponent:
        return [
          <EditGeckoComponentDrawer key='edit-component' />,
          EditGeckoComponentDrawerProps,
        ]
      case DrawerState.UploadFile:
        return [<UploadFileDrawer key='upload-file' />, UploadFileProps]
      case DrawerState.UploadHHUTFile:
        return [<UploadHHUTFile key='upload-hhut-file' />, GeckoHHUTFileProps]
      case DrawerState.CreateSystem:
        return [
          <CreateSystemDrawer key='create-system' />,
          CreateSystemDrawerProps,
        ]
      case DrawerState.ImportSymbol:
        return [
          <div key='import-symbol' style={{ height: '100%' }}>
            <SymbolImport />
          </div>,
          { title: 'Import Symbol', width: '50vw' },
        ]
      default:
        return [
          <div key='unexpected-drawer-state'>
            Unexpected Drawer State! Drawer State: {DrawerState[drawerState]}
          </div>,
          undefined,
        ]
    }
  }

  const [childElement, otherProps] = getChildElements()

  return (
    <GeckoNotificationProvider>
      <Drawer
        aria-modal='true'
        {...otherProps}
        open={
          drawerState !== DrawerState.Closed &&
          drawerState !== DrawerState.UploadingState
        }
        onClose={closeDrawer}
        maskClosable={false}>
        {childElement}
      </Drawer>
    </GeckoNotificationProvider>
  )
}
